export const dateAndTimeIntoISTFormat = (incomingDateTime: any) => {
  const istDate = new Date(incomingDateTime)
  const formattedISTDate = istDate.toISOString()

  return incomingDateTime ? formattedISTDate : null
}

export default dateAndTimeIntoISTFormat
